module.exports = __webpack_public_path__ + "b3193bf2c5c1fc82fd2a0052b554b851.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/termine/Nagelritz.jpg
// module id = 852
// module chunks = 0